var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-5"},[_c('p',{staticClass:"is-size-3"},[_vm._v("Häkelmuster")]),_c('a',{attrs:{"href":"/static/haakpatroon/patroon.pdf"}},[_c('img',{staticClass:"img-fluid shadow",attrs:{"src":"/static/haakpatroon/patroon.jpg"}})])])])])])
}]

export { render, staticRenderFns }